<template>
	<form :class="[isInline]">
		<slot></slot>
	</form>
</template>

<script>
	export default {
		name: 'bsf-form',
		components: {},
		props: {
			direction: {
				type: String
			}
		},
		data: function() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			isInline(){
				return this.direction?"form-"+this.direction:"";
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.form-control {
		input& {
			.unbdr;
		}
	}
</style>


// WEBPACK FOOTER //
// form.vue?48c0220a